(function(Modal) {
    'use strict';

    Modal.elements = {
        gallery: '.js-modal-gallery'
    };

    Modal.gallery = function() {
        $(Modal.elements.gallery).magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            callbacks: {
                change: function() {
                    if (this.isOpen) {
                        this.wrap.addClass('mfp-open');
                    }
                }
            }
        });
    };
})(window.Way2web.Modal = window.Way2web.Modal || {});
